export const GPT_BASE_URL = "https://gpt.cocorobo.cn";
// export const GPT_BASE_URL = "http://localhost:8000";
